import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { UserService } from '../../../../services/user.service';
import { AdministrationService } from '../../../../services/administration.service';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { MatDialog } from '@angular/material';
import { WMSValidators } from '../../../../shared/validators';
import { AddNewAccountOfficeStateGovernmentDialog } from './dialog.addnewaccoffice';
import { EditAccountOfficeStateGovernmentDialog } from './dialog.editaccoffice';

@Component({
  selector: 'app-state-government',
  templateUrl: './state-government.component.html',
  styleUrls: ['./state-government.component.css']
})
export class AccountOfficeStateGovernmentComponent implements OnInit, OnDestroy {
  allSub: Subscription[] = [];
  accOffListform: FormGroup;
  warrantAuthCode: string = 'NG';
  errorMessage: string = '';
  isLoading: boolean = false;
  userName: string = '';
  screenCode: string = '';

  p: number = 1;
  datasource: any[];
  totalCount: number = 0;

  constructor(private userService: UserService,
    private administrationService: AdministrationService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog) {
    let user = this.userService.getUser();
    this.userName = user.username;
    this.screenCode = user.screenCode;
  }

  ngOnInit() {
    this.accOffListform = new FormGroup({
      accOffCode: new FormControl({ value: '', disabled: false }, [Validators.maxLength(32767)]),
      accOff: new FormControl({ value: '', disabled: false }, [Validators.maxLength(32767)]),
      mailTo: new FormControl({ value: '', disabled: false }, [Validators.maxLength(32767)]),
      mailCC: new FormControl({ value: '', disabled: false }, [Validators.maxLength(32767)]),
      mailBCC: new FormControl({ value: '', disabled: false }, [Validators.maxLength(32767)])
    });

    let getAccOff = {
      Page: this.p,
      AccOffCode: this.accOffListform.get('accOffCode')!.value,
      AccOff: this.accOffListform.get('accOff')!.value,
      MailTo: this.accOffListform.get('mailTo')!.value,
      MailCc: this.accOffListform.get('mailCC')!.value,
      MailBcc: this.accOffListform.get('mailBCC')!.value
    };
    this.isLoading = true;

    let init_sub = this.administrationService.getNgrAccountOfficeList(getAccOff)
      .subscribe(
        (value) => {
          this.isLoading = false;
          if (value.status === 204) {

          } else if (value.status === 200) {
            this.datasource = value.body['accountOffices'];
            this.totalCount = value.body['totalCount'];
            this.p = 1;
          } else {
            this.openSnackBar('Error retrieving account office list.', '');
          }
        },
        (error) => {
          this.isLoading = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(init_sub);
  }

  addNewAccOffice() {
    let dialogRef = this.dialog.open(AddNewAccountOfficeStateGovernmentDialog, {
      width: '60%',
      disableClose: true,
      data: {
        warrantauthcode: this.warrantAuthCode
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Add new successful') {
        this.nextPage(1);
        this.openSnackBar('New Account Office Added', '');
      }
    });
  }

  searchTransaction(form: FormGroup) {
    let getAccOff = {
      Page: 1,
      AccOffCode: this.accOffListform.get('accOffCode')!.value,
      AccOff: this.accOffListform.get('accOff')!.value,
      MailTo: this.accOffListform.get('mailTo')!.value,
      MailCc: this.accOffListform.get('mailCC')!.value,
      MailBcc: this.accOffListform.get('mailBCC')!.value
    };
    this.isLoading = true;

    let search_sub = this.administrationService.getNgrAccountOfficeList(getAccOff)
      .subscribe(
        (value) => {
          this.isLoading = false;
          if (value.status === 204) {

          } else if (value.status === 200) {
            this.p = 1;
            this.datasource = value.body['accountOffices'];
            this.totalCount = value.body['totalCount'];
          } else {
            this.openSnackBar('Error retrieving account office list.', '');
          }
        },
        (error) => {
          this.isLoading = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(search_sub);
  }

  openEditAccDialog(accOffCode: string, accOff: string, emailTo: string, emailCc: string, emailBcc: string) {
    let dialogRef = this.dialog.open(EditAccountOfficeStateGovernmentDialog, {
      width: '60%',
      disableClose: true,
      data: {
        warrantauthcode: this.warrantAuthCode,
        accoffcode: accOffCode,
        accoff: accOff,
        emailto: emailTo,
        emailcc: emailCc,
        emailbcc: emailBcc
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Edit successful') {
        this.nextPage(1);
        this.openSnackBar('Change(s) Saved', '');
      }
    });
  }

  deleteAcc(accOffCode: string) {
    let cfm = confirm("Are you sure you want to delete the selected Account Office?");

    if (cfm) {
      this.isLoading = true;

      let accountOfficeDetail = {
        WarrantAuthCode: this.warrantAuthCode,
        AccOffCode: accOffCode,
        AccOff: '',
        MailTo: '',
        MailCc: '',
        MailBcc: ''
      }

      let save_sub = this.administrationService.ngrDeleteAccOff(accountOfficeDetail)
        .subscribe(
          (value) => {
            if (value.status === 204) {

            } else if (value.status === 200) {
              this.isLoading = false;
              this.openSnackBar(value.body ? value.body.toString() : '', '');
            } else {

            }
          },
          (error) => {
            this.errorMessage = <any>error;
            this.openSnackBar(this.errorMessage, '');
          });

      //Adds into array for each subscribe
      this.allSub.push(save_sub);
    } else {
      this.isLoading = false;
    }
  }

  nextPage(page: number) {
    this.isLoading = true;
    let getAccOff = {
      Page: page,
      AccOffCode: this.accOffListform.get('accOffCode')!.value,
      AccOff: this.accOffListform.get('accOff')!.value,
      MailTo: this.accOffListform.get('mailTo')!.value,
      MailCc: this.accOffListform.get('mailCC')!.value,
      MailBcc: this.accOffListform.get('mailBCC')!.value
    };

    let update_sub = this.administrationService.getNgrAccountOfficeList(getAccOff)
      .subscribe(
        (value) => {
          this.isLoading = false;
          if (value.status === 204) {

          } else if (value.status === 200) {
            this.p = page;
            this.datasource = value.body['accountOffices'];
            this.totalCount = value.body['totalCount'];
          } else {
            this.openSnackBar('Error retrieving account office list.', '');
          }
        },
        (error) => {
          this.isLoading = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(update_sub);
  }

  ngOnDestroy() {
    for (let sub of this.allSub) {
      sub.unsubscribe();
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
}
